import { render, staticRenderFns } from "./SetNewPassword.vue?vue&type=template&id=53b90d88&scoped=true&"
import script from "./SetNewPassword.vue?vue&type=script&lang=js&"
export * from "./SetNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./SetNewPassword.vue?vue&type=style&index=0&id=53b90d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b90d88",
  null
  
)

component.options.__file = "SetNewPassword.vue"
export default component.exports